export interface DerivedBillingParams {
  ageThresholdMonths: number;
  timing: string;
}

// AgeTransitionConfig is the per-contract (tariff-version-derived) age-transition
// configuration, replacing the former org-level billing settings as the source
// of the BABY/CHILD threshold + timing. Fields are camelCase (the API/transformer
// shape on the web side).
export interface AgeTransitionConfig {
  ageTransitionMonths: number;
  ageTransitionMonthsSubsidised: number;
  ageTransitionTiming: string;
}

export function deriveBillingParams(
  config: AgeTransitionConfig | undefined,
  isSubsidised: boolean
): DerivedBillingParams {
  if (!config) {
    throw new Error('Age transition config is required for calculation');
  }

  const ageThresholdMonths = isSubsidised
    ? config.ageTransitionMonthsSubsidised
    : config.ageTransitionMonths;

  if (!Number.isFinite(ageThresholdMonths) || ageThresholdMonths <= 0) {
    throw new Error('Invalid age transition months in config');
  }

  return {
    ageThresholdMonths,
    timing: config.ageTransitionTiming,
  };
}

